import { render, staticRenderFns } from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=template&id=dc2da5c6"
import script from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=style&index=0&id=dc2da5c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports